import React, { useEffect, useMemo } from "react";
import { Form, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import Dropzone from "react-dropzone";
import Delete from "../../assets/icons/deleteA.svg";
import UploadIcon from "../../assets/icons/UploadGray.svg";
import './DragDrop.css';
import Alert from "./Alert";
import ResponsiveTable from "../Grid/ResponsiveTable";

function DragDropRender(props) {
    let action = props.action;
    console.log("drag drop value", props.val);

    let disableFlag = props.hasOwnProperty("disabled") ? props.disabled : false;
    let supportedFormats = props.supportedFilesLabel;

    const validateMandatory = () => {
        const hasValue = props.isMultiple ? (props.val && props.val.length > 0) : props.val;
        if (!hasValue) {
            if (!props.mandatoryFields?.includes(props.name)) {
                props.setMandatoryFields && props.setMandatoryFields((prev) => ([...prev, props.name]));
            }
            return `${props.label} is mandatory \n`;
        } else {
            props.setMandatoryFields && props.setMandatoryFields(prev => prev.filter(field => field !== props.name));
            return "";
        }
    };

    useEffect(() => {
        if (props.required) {
            const hasValue = props.isMultiple ? (props.val && props.val.length > 0) : props.val;
            if (hasValue) {
                allValidations();
            } else {
                props.setMandatoryFields && props.setMandatoryFields(prev => (prev.includes(props.name) ? prev : [...prev, props.name]));
            }
        } else if (props.mandatoryFields?.includes(props.name)) {
            props.setMandatoryFields && props.setMandatoryFields(prev => prev.filter(field => field !== props.name));
        }
    }, [props.val, props.required]);

    const allValidations = async () => {
        // debugger
        let errorMsg = "";
        if (props.required) {
            errorMsg = validateMandatory();
        }
        if (props.setError) { props.setError((prev) => ({ ...prev, [props.name]: errorMsg })); }
    };

    const handleInvalidUpload = (reasons) => {
        let mb = (props.maxSize / 1048576);
        let errMsg = "";
        for (let error of reasons.errors) {
            if (error.code === 'file-invalid-type') {
                errMsg = "Only pdf and excel files are allowed";
            }
            if (error.code === 'file-too-large') {
                errMsg = "File size is greater than " + mb + "MB.";
            }
            if (error.code === 'too-many-files') {
                errMsg = `Maximum ${props.maxFiles} files allowed.`;
            }
        }
        if (props.isSetError) {
            props.setError((prev) => ({ ...prev, [props.name]: errMsg }))
        } else {
            Alert('error', errMsg);
        }
    };

    const checkDuplicateFileNames = (newFiles, existingFiles) => {
        const existingNames = existingFiles.map(file => typeof file === 'string' ? file : file.name);
        const duplicates = newFiles.filter(file => existingNames.includes(file.name));
        
        if (duplicates.length > 0) {
            const errMsg = `File(s) with the same name already exist: ${duplicates.map(f => f.name).join(', ')}`;
            if (props.isSetError) {
                props.setError((prev) => ({ ...prev, [props.name]: errMsg }));
            } else {
                Alert('error', errMsg);
            }
            return false;
        }
        return true;
    };

    const validateTotalSize = (newFiles, existingFiles) => {
        if (!props.maxTotalSize) return true;

        const existingSize = existingFiles.reduce((sum, file) => sum + (file.size || 0), 0);
        const newSize = newFiles.reduce((sum, file) => sum + file.size, 0);
        const totalSize = existingSize + newSize;

        if (totalSize > props.maxTotalSize) {
            const errMsg = `Total file size cannot exceed ${(props.maxTotalSize / 1048576).toFixed(0)}MB. Current: ${(totalSize / 1048576).toFixed(2)}MB`;
            if (props.isSetError) {
                props.setError((prev) => ({ ...prev, [props.name]: errMsg }));
            } else {
                Alert('error', errMsg);
            }
            return false;
        }
        return true;
    };

    console.log("props.val", props);

    const handleFileDownload = (file, index) => {
        if (props.handleDownloadDocEvent) {
            props.handleDownloadDocEvent(file);
        }
    };


    const hasFiles = props.isMultiple ? (props.val && props.val.length > 0) : props.val;
    const fileList = props.isMultiple ? (props.val || []) : (props.val ? [props.val] : []);
    console.log('dragdropfiles', fileList);
    const readOnlyCount = props.readOnlyCount || 0;
    const canAddMore = props.isMultiple && fileList.length < props.maxFiles;

    return (
        <Form.Group className={`dropzone-fileupload${props.dropzoneVariant === "dragdrop" ? " dropzone-dragdrop" : ""}`}>
            {action !== "View" && (!hasFiles || canAddMore) && (
                <div className="dropZoneContainer">
                    <Dropzone
                        onDropAccepted={(acceptedFiles) => {
                            if (props.isMultiple && !validateTotalSize(acceptedFiles, fileList)) {
                                return;
                            }
                            if (!checkDuplicateFileNames(acceptedFiles, fileList)) {
                                return;
                            }
                            props.handleChangeEvent(acceptedFiles);
                            allValidations();
                        }}
                        onDropRejected={(info) => {
                            handleInvalidUpload(info[0]);
                        }}
                        onFileDialogCancel={() => {
                            allValidations();
                        }}
                        multiple={props.isMultiple}
                        maxFiles={props.isMultiple ? props.maxFiles - fileList.length : props.maxFiles}
                        maxSize={props.maxSize}
                        accept={props.acceptedExtensions}
                        disabled={disableFlag}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} className="dropZoneMainDiv">
                                <input {...getInputProps()} />
                                <div className="dropTextContainer">
                                    <Row className="DropBox-row">
                                        <span className="semiBoldToggleButton">
                                            {props.dropzoneVariant === "dragdrop" ? (
                                                <>
                                                    <img src={UploadIcon} alt="upload" className="upload-icon" />
                                                    <span className="dropDragText">Drag and drop file here or </span>
                                                    <span className="dropSelectText">Browse file</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span className="dropSelectText">
                                                        <img src={UploadIcon} alt="upload" />
                                                        Browse File </span>
                                                    / Attach File{props.isMultiple && 's'} {props.required && <span className="required-field godrej-red"> *</span>}&nbsp;
                                                    {props.isMultiple && `(${fileList.length}/${props.maxFiles})`}
                                                </>
                                            )}
                                        </span>
                                        {!props.dropzoneVariant && (
                                            <span className="dropSelectfiles">
                                                {supportedFormats}
                                            </span>
                                        )}
                                    </Row>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                </div>
            )}
            {hasFiles && !props.tableLayout && (
                <Row>
                    <Col className="file-attachment">
                        {fileList.map((file, index) => (
                            <div key={index} className='inline-buttons uploaded-wrapper'>
                                <Form.Text>
                                    {file.size}
                                </Form.Text>
                                <span>

                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={<Tooltip className="custom-tooltip">{file}</Tooltip>}
                                    >
                                        <Form.Text 
                                            className="fileupload-name" 
                                            onClick={() => handleFileDownload(file, index)}
                                            style={{ 
                                                cursor: 'pointer', 
                                                color: '#007bff', 
                                                textDecoration: 'none'
                                            }}
                                            onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                            onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                        >
                                            {file}
                                        </Form.Text>
                                    </OverlayTrigger>

                                    {action != 'View' &&
                                        <img
                                            className="action-icon"
                                            src={Delete}
                                            alt="delete"
                                            onClick={() => props.handleDeleteDocEvent(index)}
                                        />
                                    }
                                </span>
                            </div>
                        ))}
                    </Col>
                </Row>
            )}
            {hasFiles && props.tableLayout && (
                <div className="file-table-container">
                    <ResponsiveTable
                        sessionName=""
                        dataType="fileAttachments"
                        headers={[
                            { columnName: "fileName", displayName: "File name", displayIndication: true, width: 250 },
                            { columnName: "fileFormat", displayName: "File format", displayIndication: true, width: 150 },
                            { columnName: "fileSize", displayName: "File size", displayIndication: true, width: 150 },
                        ]}
                        data={fileList.map((file, index) => {
                            console.log("this is new file", file);
                            
                            const fileName = typeof file === 'string' ? file : (file.name || file.fileName || '');
                            const ext = fileName.split('.').pop().toLowerCase();
                            let fileSize = '----';
                            if (typeof file === 'object' && file.size) {
                                fileSize = file.size >= 1024 * 1024
                                    ? (file.size / (1024 * 1024)).toFixed(1) + ' mb'
                                    : (file.size / 1024).toFixed(1) + ' kb';
                            } else if (typeof file === 'object' && file.fileSize) {
                                fileSize = file.fileSize;
                            } else if (props.fileSizes && props.fileSizes[index]) {
                                const size = props.fileSizes[index];
                                fileSize = size >= 1024 * 1024
                                    ? (size / (1024 * 1024)).toFixed(1) + ' mb'
                                    : (size / 1024).toFixed(1) + ' kb';
                            }
                            return { fileName, fileFormat: ext, fileSize, _index: index, _isReadOnly: index < readOnlyCount, _file: file };
                        })}
                        icons={action !== 'View' ? [{
                            src: Delete,
                            name: "Delete",
                            click: (item) => {
                                if (item._isReadOnly) return;
                                props.handleDeleteDocEvent(item._index - readOnlyCount);
                            }
                        }] : []}
                        paginationView="false"
                        noCheckbox={true}
                        DisplayExcelDownload={false}
                        isSearchOpen={false}
                    />
                    <div className="file-table-footer">Total Documents: <span>{fileList.length}</span></div>
                </div>
            )}
            {props.error && props.error[props.name] && (
                <Form.Text className="text-danger">
                    {props.error[props.name]}
                </Form.Text>
            )}
        </Form.Group>
    );
}

export default DragDropRender;